import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/StorefrontPages.css';

const LINKS_NAV = [
  { to: '/', label: 'Главное' },
  { to: '/articles/1', label: 'Статьи' },
  { to: '/contact', label: 'Контакты' },
];
const LINKS_INFO = [
  { to: '/contact', label: 'Доставка и оплата' },
  { to: '/contact', label: 'Условия сотрудничества' },
  { to: '/contact', label: 'О компании' },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="sffooter">
      <div className="sffooter__inner">
        <div>
          <h4 className="sffooter__brand-name">MB4</h4>
          <p className="sffooter__brand-text">
            Фермерская мраморная говядина прямой поставки. Контракты с HoReCa и регулярные заказы по Алматы и области.
          </p>
        </div>
        <div>
          <h5 className="sffooter__col-title">Навигация</h5>
          <ul className="sffooter__list">
            {LINKS_NAV.map((l) => <li key={l.label}><Link to={l.to}>{l.label}</Link></li>)}
          </ul>
        </div>
        <div>
          <h5 className="sffooter__col-title">Информация</h5>
          <ul className="sffooter__list">
            {LINKS_INFO.map((l) => <li key={l.label}><Link to={l.to}>{l.label}</Link></li>)}
          </ul>
        </div>
        <div>
          <h5 className="sffooter__col-title">Контакты</h5>
          <ul className="sffooter__list">
            <li><a href="tel:+77270000000">+7 (727) 000-00-00</a></li>
            <li><a href="mailto:sales@mb4.kz">sales@mb4.kz</a></li>
            <li>Алматы, Розыбакиева 247</li>
          </ul>
        </div>
      </div>
      <div className="sffooter__bottom">
        <span>© {year} MB4. Все права защищены.</span>
        <span>Сделано для HoReCa и партнёров Казахстана.</span>
      </div>
    </footer>
  );
}
